<template>
  <div class="size1 bg0 where1-parent " style="display:flex">

    <Loader :isVisible.sync="isloader" :text="'Carregando'" />

    <div
      class="size3 flex-col-sb flex-w p-l-50 p-t-25 respon1 reponsive-celular"
      style="justify-content: space-around; align-items: center;"
    >
      <center>
        <img src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg" class="icon-login" />
        <p class="texto-sistema">DBV - Declaração de Bens e Valores</p>
      </center>

      <p class="m1-txt1">
        Declaração Anual de Bens e Valores dos servidores e empregados públicos do Estado de Mato Grosso
      </p>

      <div class="p-b-10 p-t-5">
        <form ref="formRef" class="p-grid p-fluid">
          <div
            class="wrap-input100 m-b-10 validate-input"
            data-validate="Name is required"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="text"
              id="login"
              name="email"
              placeholder="Usuário"
              v-model="user.login"
            />
            <span class="focus-input100"></span>
          </div>
          <div
            class="wrap-input100 m-b-20 validate-input"
            data-validate="Email is required: ex@abc.xyz"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="password"
              id="senha"
              name="password"
              v-model="user.senha"
              placeholder="Senha"
              v-on:keyup.enter="logar()"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="w-full">
            <button
              class="flex-c-m s2-txt2 size4 bg1 bor1 hov1 trans-04"
              type="button"
              @click="logar()"
            >
              Fazer Login
            </button>
          </div>
        </form>
        <div class="p-grid p-fluid" style="margin-top: 0.1rem;">
          <p
            class=" p-col-6 p-t-18"
            style="cursor:pointer"
            @click="resetarSenha()"
          >
            Esqueci a minha senha
          </p>
          <p
            class="p-col-6 p-md-4 p-md-offset-2 p-t-18"
            style="cursor:pointer;text-align: right;"
            @click="obterInfAcesso()"
          >
            Informações
          </p>
        </div>
      </div>

      <!-- <div class="p-col-12"> -->
        <img src="@/assets/produto-STI.png" class="img-footer-phone" />
      <!-- </div> -->

    </div>

    <div
      class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display"
      style=""
    >
    </div>

    <!-- MODAL FAQ -->
    <Dialog
      header="Instruções de acesso:"
      class="cadastro-rapido-seplag"
      :visible.sync="exibirTelaInstrucao"
      :contentStyle="{ width: '50vw' }"
      :modal="true"
      v-if="exibirTelaInstrucao"
    >
      <div class="p-col-12">
        <p style="font-size:1rem;text-align: center; font-weight: bold;">
          Bem-vindo(a) à Declaração Anual de Bens!
        </p>
        <br />
        <p style="font-size:1rem;text-align: justify;margin-bottom: 0.57rem;">
          <i class="pi pi-check"></i> Para acessar o sistema:
        </p>
        <ul style="margin-left:1vw; margin-bottom: 0.57rem;">
          <li>
            <i class="bottom pi pi-circle-on" style="fontSize: 0.8rem;margin:auto 10px"></i>Servidor
            público: “usuário”: CPF funcional e senha, mesma utilizada
            para acessar o Portal do Servidor.
          </li>
          <li>
            <i class=" bottom pi pi-circle-on" style="fontSize: 0.8rem;margin:auto 10px"></i>Empregado
            público: “usuário”: CPF.
          </li>
          <li>
            <i class="pi pi-circle-on" style="fontSize: 0.8rem;margin:auto 10px"></i>Caso não
            possua usuário e senha, clique na opção ESQUECI MINHA SENHA para
            ativar.
          </li>
        </ul>
        <p style="font-size:1rem;text-align: justify;margin-bottom: 0.57rem;">
          <i class="pi pi-check"></i> Declaração Anual de Bens é obrigatória aos Servidores e Empregados Públicos Ativos da Administração Direta e Indireta, Autárquica e Fundacional do Poder Executivo do Estado de Mato Grosso. A obrigação estende-se aos que se encontram cedidos, afastados, permutados ou licenciados.
        </p>
      </div>
      <template #footer>
        <Button
          :label="'ok'"
          icon="pi pi-check"
          @click="fecharTelaInstrucao"
          class="p-button-success"
        />
      </template>
    </Dialog>

    <!-- MODAL ESQUECI A MINHA SEENHA -->
    <cadastro-rapido
      tituloTela="Esqueci a minha senha"
      tamanhoTela="25.rem"
      v-model="exibirTelaSenha"
      :modoEdicao="modoEdicao"
      :onEnviarLinkAtivacao="alterarRegistro"
    >
      <div class="p-col-12">
        <!-- <Rotulo nome="Usuário" cols="12">
          <InputText type="text" v-model="registro.matricula" v-required />
        </Rotulo> -->
        <Rotulo nome="CPF" cols="12">
          <InputMask
            mask="999.999.999-99"
            type="text"
            v-model="registro.cpf"
            v-required
          />
        </Rotulo>
        <Rotulo nome="Data Nascimento" cols="12">
          <InputMask
            mask="99/99/9999"
            placeholder="dd/mm/aaaa"
            v-model="registro.dataNascimento"
            v-required
          />
        </Rotulo>
      </div>
    </cadastro-rapido>

    <!-- MODAL DOCUMENTOS -->
    <cadastro-rapido
      :tituloTela="tituloTabelaDocumento"
      tamanhoTela="450"
      v-model="exibirTelaDocumentos"
    >
      <div class="p-col-12">
        <DataTable :value="documentos">
          <Column field="nomeDocumento"> </Column>
          <Column headerStyle="width: 6em" bodyStyle="text-align: center">
            <template #body="">
              <Button
                type="button"
                icon="pi pi-download"
                class="p-button-success"
                style="margin-right: .5em"
              >
                Visualizar</Button
              >
            </template>
          </Column>
        </DataTable>
      </div>
    </cadastro-rapido>

    <!-- MODAL CONFIRMA ALTERAR SENHA -->
    <Dialog
      header="Confirmação"
      :visible.sync="exibirModalConfirmacaoSenha"
      :style="{ width: '24em' }"
      :modal="true"
    >
      <div
        class="confirmation-content"
        :style="{ color: colorMenssagemConfirmacao }"
      >
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2em"
          v-if="colorMenssagemConfirmacao != '#07631e'"
        />
        <span style="text-align: justify;">{{ mensagemConfirmacao }}</span>
      </div>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharConfirmacao"
          class="p-button-text"
        />
      </template>
    </Dialog>

    <Redirect v-if="getUser" :path="namePath"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Rotulo from "@/template/RotuloSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Redirect from '@/template/Redirect.vue'
import { baseApiUrl } from "@/config/global";
import Loader from '@/paginas/Loader.vue';

const getDefaultState = () => {
  return {
    matricula: "",
    email: "",
  };
};

export default {
  name: "Login",
  computed: mapGetters(['isUserLogado','getUser','isloader']),
  components: { Rotulo, CadastroRapido,Redirect,Loader },
  modoEdicao: "logar",

  mounted() {
    this.urlLogin = window.location.origin + "/declaracaobens/auth";
    var count = Object.keys(this.$route.query).length;
    
    if (count > 0) {

      if(this.$route.query.redirect){
        this.namePath = this.$route.query.redirect
      }
      if(this.$route.query.codigo){
        this.codigoUrl = this.$route.query.codigo
        this.validarNovaSenha()
      }

    } else {
      // this.exibirTelaInstrucao = true;
    }
  },
  data: function() {
    return {
      user: {
        login: "",
        senha: "",
        identificacao: "",
        vue: this,
      },
      namePath:"/"+process.env.VUE_APP_BASE_URL,
      registro: getDefaultState(),
      codigoUrl: null,
      mensagemConfirmacao: null,
      colorMenssagemConfirmacao: "#07631e",
      exibirTelaDocumentos: false,
      exibirModalConfirmacaoSenha: false,
      modoEdicao: "alterar",
      urlLogin: null,
      tiposUsuario: [
        { flgTipo: "S", descTipo: "Servidor" },
        { flgTipo: "A", descTipo: "Aposentado" },
        { flgTipo: "P", descTipo: "Pensionista" },
      ],
      tiposLogin: [
        { flgTipo: "S", descTipo: "Servidor ou Aposentado" },
        { flgTipo: "P", descTipo: "Pensionista" },
      ],
      colunasTabelaDocumentos: [{ nomeDocumento: null }],
      documentos: [{ nomeDocumento: null }],
      tituloTabelaDocumento: "",
      selectedTipoLogin: { flgTipo: "S", descTipo: "Servidor ou Aposentado" },
      exibirTelaSenha: false,
      apiUrlRecursoBuscarServidor: "publicos/iniciaregistroservidor",
      apiUrlRecursoBuscarEmpregador: "publicos/iniciaregistroempregado",
      exibirTelaInstrucao: false,
    };
  },
  methods: {
    ...mapActions(["logarUsuario"]),
    listarDocumentos(tipoDocumento) {
      (this.exibirTelaSenha = false), (this.exibirTelaDocumentos = true);

      if (tipoDocumento == "decreto") {
        this.tituloTabelaDocumento = "Decreto de Monitoramento";
        this.documentos = [
          {
            nomeDocumento: "Decreto n.º XXXX de XXXX",
          },
        ];
      } else if (tipoDocumento == "manuais") {
        this.tituloTabelaDocumento = "Manuais e Autocapacitação";
        this.documentos = [
          { nomeDocumento: "Manual" },
          { nomeDocumento: "Apresentação do Monitoramento" },
          { nomeDocumento: "Autocapacitação" },
        ];
      } else if (tipoDocumento == "perguntas") {
        this.tituloTabelaDocumento = "Perguntas Frequentes";
        this.documentos = [
          {
            nomeDocumento: "Perguntas Frequentes",
          },
        ];
      } else if (tipoDocumento == "treinamento") {
        this.tituloTabelaDocumento = "Lista de Treinamento";
        this.documentos = [
          {
            nomeDocumento: "Lista de Treinamento",
          },
        ];
      }
    },
    resetarSenha() {
      (this.exibirTelaSenha = true), (this.exibirTelaDocumentos = false);
      this.modoEdicao = "enviaremailativacao";
    },
    obterInfAcesso() {
      (this.exibirTelaSenha = false), (this.exibirTelaInstrucao = true);
    },
    async logar() {
      if(process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS!='false'){ 
        this.$store.commit("setLoader",true)
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('login')
        if(token){
            this.$store.commit("setTokenrecaptcha",token)
            let res = await this.logarUsuario(this.user)
            if(res){
                this.$store.commit("setUserLogado",true)
            }  
        }else{
            this.$store.commit("setLoader",false)
            this.$toast.add({severity:'error', summary: "Erro ao Validar o Recaptcha, PorFavor recarregue a pagina e tente novamente", life: 15000})
        } 
      }else{
        let res = await this.logarUsuario(this.user)
        
        if(res){
            this.$store.commit("setUserLogado",true)
        }  
      }
      
    },
    validarNovaSenha() {
      var objValida = {
        codigoValidacao: this.codigoUrl,
        pathAplicacao: this.urlLogin,
        nomeSistema: process.env.VUE_APP_TITLE,
        assinaturaEmail: "COORDENADORIA DE MONITORAMENTO DE PESSOAL",
      };
      if (this.exibirTelaInstrucao) {
        this.exibirTelaInstrucao = false;
      }
      this.$http
        .post(
          `${baseApiUrl}/publicos/esquecisenha/novasenha`,
          JSON.stringify(objValida)
        )
        .then((res) => {
          this.mensagemConfirmacao = res.data.mensagem;
          this.colorMenssagemConfirmacao = "#07631e";
          this.exibirModalConfirmacaoSenha = true;
        });
      // .catch(error => {
      //     this.mensagemConfirmacao = error.response.data[0].msgUsuario
      //     this.colorMenssagemConfirmacao = "#bf1b1b"
      //     this.exibirModalConfirmacaoSenha = true
      // })
    },
    alterarRegistro() {
      var dadosForm = {
        // login: this.registro.matricula,
        cpf: this.registro.cpf,
        dataNascimento: this.registro.dataNascimento,
        pathAplicacao: this.urlLogin,
        nomeSistema: process.env.VUE_APP_TITLE,
        assinaturaEmail: "COORDENADORIA DE MONITORAMENTO DE PESSOAL",
      };
      this.$http
        .post(`${baseApiUrl}/publicos/esquecisenha`, JSON.stringify(dadosForm))
        .then((res) => {
          (this.exibirTelaSenha = false),
            this.$toast.add({
              severity: "success",
              summary: res.data.mensagem,
              life: 9000,
            });
        })
        .catch(() => {
          this.exibirTelaSenha = false;
        });
    },
    fecharConfirmacao() {
      this.exibirModalConfirmacaoSenha = false;
    },
    fecharTelaInstrucao() {
      this.exibirTelaInstrucao = !this.exibirTelaInstrucao;
    },
    isLoader() {          
      return this.$store.getters.isloader
    }
  },
  created() {
    var dataToken = null

    if(localStorage.getItem(process.env.VUE_APP_USER_KEY)){
      let dadosStorageSeplagJson = decodeURI(atob(localStorage.getItem(process.env.VUE_APP_USER_KEY)))
      dataToken = JSON.parse(dadosStorageSeplagJson)   
    } 

    if(dataToken){                
        if(!this.$store.getters.isUserLogado){
            this.$store.commit('setUserLogado', true)
        } 

        // if(!this.$store.getters.getToken){
        //    this.$store.commit('setToken', dataToken.token)
        // }
        // if(!this.$store.getters.getUser){
        //     await this.$store.dispatch('buscarUsuario',this)
            
        // }    

    }
    
    
  },
  watch:{
    isLoader(newLoader){
        this.loaderTrue = newLoader
      }
  }
};
</script>

<style scoped>

  .bottom{
    margin-bottom: 5px;
  }

  .bg1 {
    background-color: #007ad9;
  }

  .wrap-pic1 {
    width: 70%;
  }
  .bg-img1 {
    background-image: url("../../assets/declaracao.svg");
  }
  .texto-sistema {
    font-size: 2.142857rem;
    color: #005494;
    font-weight: bold;
    padding: 0;
    margin-bottom: 1vh;
  }
  .icon-login {
    width: 70%;
    margin-top: 4vw;
    margin-bottom: 3vw;
    margin-left: -2.2vw;
  }
  .img-top-phone {
    width: 90%;
    margin-top: 12vw;
    margin-left: -6vw;
  }
  .img-footer-phone {
    width: 18vw;
    /* margin-left: 8vw; */
  }
  .m1-txt1 {
    font-size: 1.28rem;
    text-align: center;
    margin-bottom: 1vh;
  }
  .s2-txt4 {
    text-transform: none;
    font-family: "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 1.07rem;
  }
  .bor2 {
    text-align: center;
    cursor: pointer;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 40em) {
    .display {
      display: none !important;
    }
    .reponsive-celular {
      padding-right: 1.85rem !important;
      padding-left: 1.28rem !important;
    }
    .wrap-pic1 {
      width: 100%;
    }
    .img-footer-phone {
      width: 37vw;
      /* margin-left: 25vw;
      margin-top: 25vw; */
    }

    .cadastro-rapido-seplag {
      width: 100% !important;
    }
    .p-dialog-content {
      width: 100% !important;
      word-wrap: break-word;
    }
  }
  @media screen and (max-width: 62em) and (min-width: 40em) {
    .display {
      display: none !important;
    }
    .reponsive-celular {
      padding-right: 26px !important;
      padding-left: 18px !important;
    }
    .wrap-pic1 {
      width: 100%;
    }
    .img-footer-phone {
      width: 37vw;
      /* margin-left: 10vw;
      margin-top: 11vw; */
    }
  }

  .p-t-18{
    font-size : 1rem;
  }

  .s2-txt1{
    font-family: Lato-Bold;
    font-size: 1.214285714285714rem;
    line-height: 1.5;
    color: #555555;
  }
</style>
